





























import { Component, Vue } from 'vue-property-decorator'
import ProjectGrid from '@/components/ProjectGrid.vue' // @ is an alias to /src
import YoutubeEmbed from '@/components/YoutubeEmbed.vue'
@Component({ components: { ProjectGrid, YoutubeEmbed } })
export default class extends Vue {
  public tedx = 'rYCDaXgcKCA'
  public mott = 'RIgxRhz6lmM'
  public yaa = 'nsRYD3vydis'
}
